import { Skeleton } from '@/components/ui'

// Mirrors ProjectCaseFields: the case-type select and the account-type chips, each under its
// label. The detail fields in between vary by case type, so they get no placeholder.
export const CaseFormSkeleton = () => (
  <div className="flex flex-col items-start gap-4">
    <div className="flex w-full max-w-sm flex-col items-start gap-2">
      <Skeleton className="h-5 w-24" />
      <Skeleton className="h-10 w-full" />
    </div>
    <div className="flex flex-col items-start gap-2">
      <Skeleton className="h-5 w-28" />
      <div className="flex flex-wrap gap-2">
        <Skeleton className="h-9 w-40" />
        <Skeleton className="h-9 w-40" />
        <Skeleton className="h-9 w-52" />
      </div>
    </div>
  </div>
)
